import { Box, createStyles, makeStyles, Typography } from '@material-ui/core'
import { format } from 'date-fns';
import { DateMetadataInterface } from 'myfitworld-model/dist/enums/DateMetadata'
import React from 'react'
import { useIntl } from 'react-intl';
import firebase from 'firebase/app';
import messages from './messages';
const useStyles = makeStyles(() =>
  createStyles({
    container: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "flex-end",
      margin: 30,
    },

  }),
);

export const formatDateModifiedView = (dateModified: any): Date => {
  if (dateModified instanceof Date) {
    return dateModified;
  } else if (dateModified instanceof firebase.firestore.Timestamp) {
    return dateModified.toDate();
  } else if (
    dateModified &&
    typeof dateModified.seconds === 'number' &&
    typeof dateModified.nanoseconds === 'number'
  ) {
    return new Date(dateModified.seconds * 1000 + dateModified.nanoseconds / 1_000_000);
  } else {
    return new Date();
  }
};

function DateMetadataPreview({ dateMetadata }: { dateMetadata: DateMetadataInterface }) {
  const dateModified: Date = formatDateModifiedView(dateMetadata.dateModified);
  const classes = useStyles();
  const { formatMessage } = useIntl();

  return (
    <Box className={classes.container}>
      <Typography variant='body2'>{formatMessage(messages.lastEdit)} {format(dateModified, "dd/MM/yyyy HH:mm")}</Typography>
    </Box>
  )
}

export default DateMetadataPreview